import { getTroubleshootingState } from './troubleshooting-state';
export const getCloseTimeout = (state) => getTroubleshootingState(state).closeTimeout;
